module.exports = __webpack_public_path__ + "static/media/PoolUp_Terms_of_Service.7000c85e.pdf";